import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { FaCalendarAlt } from 'react-icons/fa';
import styles from './styles.module.scss';
import APopover from '../../a-popover';
import { CalendarIcon } from "assets/img/svg/calendarIcon";


const Input = (props) => {
  const {
    placeholder,
    height = "31px",
    width = "100%",
    fontSize = "12px",
    style,
    value,
    disabled,
    onClick,
  } = props;

  console.log("value---", value);

  const getDisplayValue = () => {
    if (!value) return "";

    // ✅ multi mode FIRST
    if (Array.isArray(value)) {
      return value.length ? value.join(", ") : "";
    }

    // ✅ range mode
    if (typeof value === "object") {
      const { start, end } = value || {};
      if (start && end) return `${start} - ${end}`;
      if (start) return `${start}`;
      return "";
    }

    return value;
  };

  return (
    <div className={styles['new-calender']} onClick={onClick}>
      <input
        type="text"
        placeholder={placeholder}
        value={getDisplayValue()}
        readOnly
        disabled={disabled}
        className={value ? styles.custom_input : ""}
        style={{ height, width, fontSize, ...style }}
      />

      <span className={styles['calendar-icon']}>
        <CalendarIcon isActive={!!value} />
      </span>
    </div>
  );
};

const DayPicker = ({
  mode = 'multi',
  value,
  onChange,
  onClose,
}) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleDayClick = (day) => {
    if (mode === 'multi') {
      setLocalValue((prev) => {
        if (prev.includes(day)) {
          return prev.filter((d) => d !== day);
        }
        return [...prev, day].sort((a, b) => a - b);
      });
    } else {
      setLocalValue((prev) => {
        const { start, end } = prev || {};
        if (!start || (start && end)) {
          return { start: day, end: null };
        }
        return {
          start: Math.min(start, day),
          end: Math.max(start, day),
        };
      });
    }
  };

  const isSelected = (day) => {
    if (mode === 'multi') {
      return localValue?.includes(day);
    }
    const { start, end } = localValue || {};
    if (!start) return false;
    const s = start;
    const e = end ?? start;
    return day >= Math.min(s, e) && day <= Math.max(s, e);
  };

  const handleClear = () => {
    setLocalValue(mode === 'multi' ? [] : { start: null, end: null });
  };

  const handleSelectAll = () => {
    if (mode === 'multi') {
      setLocalValue(Array.from({ length: 31 }, (_, i) => i + 1));
    }
  };

  const handleDone = () => {
    onChange(localValue);
    onClose();
  };

  const headerText = mode === 'multi'
    ? 'Select trigger days (multiple)'
    : 'Select start date';

  const selectedText = mode === 'multi'
    ? `${localValue?.length || 0} day${localValue?.length !== 1 ? 's' : ''} selected`
    : (() => {
      const { start, end } = localValue || {};
      if (start && end) return `Start: ${start} | End: ${end}`;
      if (start) return `Start: ${start}`;
      return '';
    })();

  return (
    <div className={styles.dayPicker}>
      {/* Header */}
      <div className={styles.header}>
        <Typography variant="subtitle1" className={styles.title}>
          {headerText}
        </Typography>
        <Typography variant="body2" className={styles.selectedText}>
          {selectedText}
        </Typography>
      </div>

      {/* Calendar Grid - Fixed 31 days */}
      <div className={styles.calendarGrid}>
        {Array.from({ length: 31 }, (_, i) => {
          const day = i + 1;
          const selected = isSelected(day);
          return (
            <div
              key={day}
              onClick={() => handleDayClick(day)}
              className={`${styles.day} ${selected ? styles.daySelected : ''}`}
            >
              {day}
            </div>
          );
        })}
      </div>

      {/* Action Buttons */}
      <div className={styles.actions}>
        <Button variant="outlined" onClick={handleClear}>
          Clear
        </Button>

        {mode === 'multi' && (
          <Button variant="outlined" onClick={handleSelectAll}>
            Select All
          </Button>
        )}

        <Button variant="contained" onClick={handleDone}>
          Done
        </Button>
      </div>
    </div>
  );
};

// export default DayPicker;

const DayPickerV2 = ({
  mode = 'multi',
  value,
  onChange,
  input,
  placeholder = '01-Jan-2022',
  disabled
}) => {

  const inputProp = {
    height: input?.height || "31px",
    width: input?.width || "180px",
    fontSize: input?.fontSize || "12px",
    placeholder: placeholder,
    value: value,
    disabled: disabled
  }

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <Input  {...inputProp} onClick={onClick} style={styles} />
      )}
      menuComponent={(handleClose) => (
        <DayPicker
          mode={mode}
          value={value}
          onChange={onChange}
          onClose={handleClose}
        />
      )}
      width={340}          // matches the calendar width
      anchorOriginVertical="bottom"
      anchorOriginHorizontal="left"
    />
  );

}

export default DayPickerV2;